export default {
  crm: {
    title: 'CRM',
    dashboard: 'Tableau de bord',
    companies: 'Entreprises',
    prospects: 'Fiches prospect',
    contacts: 'Contacts',
    interactions: 'Interactions',
    back_to_app: 'Retour',

    // Navigation tabs
    tab_dashboard: 'Tableau de bord',
    tab_pipeline: 'Pipeline',
    tab_prospects: 'Prospects',
    new_prospect_btn: '+ Nouveau Prospect',

    // Dashboard stats
    stat_total_prospects: 'Total Prospects',
    stat_active_prospects: 'Prospects actifs',
    stat_hot_prospects: 'Prospects chauds',
    stat_converted_month: 'Convertis ce mois',
    pipeline_breakdown: 'R\u00E9partition du pipeline',
    conversion_stats: 'Statistiques de conversion (30j)',
    conversion_rate: 'Taux de conversion',
    created_30d: 'Cr\u00E9\u00E9s',
    converted_30d: 'Convertis',
    avg_delay: 'D\u00E9lai moyen',
    days: 'jours',
    recent_activity: 'Activit\u00E9 r\u00E9cente',
    view_pipeline: 'Voir le pipeline',

    // Pipeline
    pipeline_title: 'Pipeline',
    pipeline_total_value: 'Valeur totale',
    pipeline_avg_deal: 'Panier moyen',
    temperature_hot: 'Chaud',
    temperature_warm: 'Ti\u00E8de',
    temperature_cold: 'Froid',
    score: 'Score',
    prospect_moved: 'Prospect d\u00E9plac\u00E9',
    no_prospects_in_column: 'Aucun prospect',

    // Prospect detail
    company_info: "Informations de l'entreprise",
    contact_info: 'Contact',
    score_card: 'Score',
    opportunities: 'Opportunit\u00E9s',
    metadata: 'M\u00E9tadonn\u00E9es',
    convert_to_exhibitor: 'Convertir en exposant',
    convert_confirm: 'Confirmer la conversion de ce prospect en exposant ?',
    convert_success: 'Prospect converti en exposant avec succ\u00E8s',
    convert_only_won:
      'Seuls les prospects gagn\u00E9s peuvent \u00EAtre convertis',
    already_converted: 'Ce prospect a d\u00E9j\u00E0 \u00E9t\u00E9 converti',
    back_to_prospects: 'Retour aux prospects',

    // Companies
    companies_management: 'Gestion des entreprises',
    company_name: "Nom de l'entreprise",
    siret: 'SIRET',
    siren: 'SIREN',
    address: 'Adresse',
    city: 'Ville',
    postal_code: 'Code postal',
    country: 'Pays',
    phone: 'T\u00E9l\u00E9phone',
    email: 'Email',
    website: 'Site web',
    notes: 'Notes',
    new_company: 'Nouvelle entreprise',
    edit_company: "Modifier l'entreprise",
    company_detail: "D\u00E9tail de l'entreprise",
    siret_lookup: 'Recherche SIRET',
    siret_lookup_placeholder: 'Entrez le num\u00E9ro SIRET...',
    siret_lookup_btn: 'Rechercher',
    siret_not_found: 'Aucune entreprise trouv\u00E9e pour ce SIRET',
    delete_company_confirm:
      '\u00CAtes-vous s\u00FBr de vouloir supprimer cette entreprise ?',
    company_created: 'Entreprise cr\u00E9\u00E9e avec succ\u00E8s',
    company_updated: 'Entreprise mise \u00E0 jour avec succ\u00E8s',
    company_deleted: 'Entreprise supprim\u00E9e avec succ\u00E8s',

    // Contacts
    first_name: 'Pr\u00E9nom',
    last_name: 'Nom',
    position: 'Poste',
    is_primary: 'Contact principal',
    new_contact: 'Nouveau contact',
    edit_contact: 'Modifier le contact',
    delete_contact_confirm:
      '\u00CAtes-vous s\u00FBr de vouloir supprimer ce contact ?',
    contact_created: 'Contact cr\u00E9\u00E9 avec succ\u00E8s',
    contact_updated: 'Contact mis \u00E0 jour avec succ\u00E8s',
    contact_deleted: 'Contact supprim\u00E9 avec succ\u00E8s',
    no_contacts: 'Aucun contact pour le moment',

    // Prospect Files
    prospect_files: 'Fiches prospect',
    new_prospect: 'Nouvelle fiche prospect',
    edit_prospect: 'Modifier la fiche prospect',
    prospect_detail: 'D\u00E9tail du prospect',
    status: 'Statut',
    priority: 'Priorit\u00E9',
    source: 'Source',
    estimated_surface: 'Surface estim\u00E9e (m\u00B2)',
    estimated_budget: 'Budget estim\u00E9',
    select_event: 'S\u00E9lectionnez un \u00E9v\u00E9nement',
    select_company: 'S\u00E9lectionnez une entreprise',
    select_contact: 'S\u00E9lectionnez un contact',
    delete_prospect_confirm:
      '\u00CAtes-vous s\u00FBr de vouloir supprimer cette fiche prospect ?',
    prospect_created: 'Fiche prospect cr\u00E9\u00E9e avec succ\u00E8s',
    prospect_updated: 'Fiche prospect mise \u00E0 jour avec succ\u00E8s',
    prospect_deleted: 'Fiche prospect supprim\u00E9e avec succ\u00E8s',
    no_prospects: 'Aucune fiche prospect pour le moment',

    // Statuses
    status_new: 'Nouveau',
    status_contacted: 'Contact\u00E9',
    status_qualified: 'Qualifi\u00E9',
    status_proposal: 'Proposition',
    status_negotiation: 'N\u00E9gociation',
    status_won: 'Gagn\u00E9',
    status_lost: 'Perdu',

    // Priorities
    priority_low: 'Basse',
    priority_medium: 'Moyenne',
    priority_high: 'Haute',

    // Interactions
    interaction_type: 'Type',
    subject: 'Sujet',
    content: 'Contenu',
    interaction_date: 'Date',
    new_interaction: 'Nouvelle interaction',
    delete_interaction_confirm:
      '\u00CAtes-vous s\u00FBr de vouloir supprimer cette interaction ?',
    interaction_created: 'Interaction cr\u00E9\u00E9e avec succ\u00E8s',
    interaction_deleted: 'Interaction supprim\u00E9e avec succ\u00E8s',
    no_interactions: 'Aucune interaction pour le moment',

    // Interaction types
    type_call: 'Appel',
    type_email: 'Email',
    type_meeting: 'R\u00E9union',
    type_note: 'Note',
    type_other: 'Autre',

    // Common
    search_placeholder: 'Rechercher...',
    no_results: 'Aucun r\u00E9sultat trouv\u00E9',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    confirm: 'Confirmer',
    actions: 'Actions',
    created_at: 'Cr\u00E9\u00E9 le',
    updated_at: 'Mis \u00E0 jour le',
  },
};
